import React from 'react';
import { Popconfirm, Form, Icon, Tooltip, Collapse } from 'antd';
import { Actions, TableSection, VariableDataContainer } from './styles';
import { TEMPLATE_VARIABLES_SIDEBAR } from '../../../artboard/VariablesList/translationValues';
import { COMPLEX_VARIABLES_SIDEBAR } from './translationValues';
import { withTranslation } from 'react-i18next';
import { VARIABLE_PRIMITIVE_TYPES, VARIABLE_TYPE } from '../../../utils/constants/appConstants';
import { ErrorLabel } from './VariableForm';

const { Panel } = Collapse;

const NAMESPACES = ['TEMPLATE_VARIABLES_SIDEBAR', 'COMPLEX_VARIABLES_SIDEBAR'];

const customPanelStyle = {
  background: '#f7f7f7',
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  overflow: 'hidden',
};
class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: props.columnData?.value || [] };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.columnData !== this.props.columnData) {
      this.setState({ data: [...this.props.columnData?.value] });
    }
  }

  handleAdd = () => {
    const { data } = this.state;
     const count = data.length
    ? Math.max(...data.map(d => parseInt(d.key.replace('block', ''), 10)))
    : 0;
    let newValues = data.length > 0 ? JSON.parse(JSON.stringify(data[0].value)) : [];

    const updateParentForNestedValues = (value, parent) => {
      value.value.forEach(eachBlock => {
        eachBlock.value.forEach(val => {
          val.parent = parent;
          if (val.type === VARIABLE_TYPE.TABLE_OBJECT) {
            updateParentForNestedValues(val.value, `${val.parent ? `${val.parent}.` : ''}${val.subKey}`);
          }
        })
      });
    }

    newValues.forEach(val => {
      val.subKey = `block${count + 1}`;
      if (val.type === VARIABLE_TYPE.TABLE_OBJECT) {
        updateParentForNestedValues(val.value, `${val.parent ? `${val.parent}.` : ''}${val.subKey}`);
      }
    });

    const newBlock = {
      key: `block${count + 1}`,
      value: newValues,
    };
    let newData = data.length > 0 ? data : [];
    newData = [...newData, newBlock];
    this.props.onChangeSampleVal(newData);
    this.setState({
      data: newData,
    });
  };

  handleDelete = key => {
    const data = [...this.state.data];
    let filteredData = data.filter(item => item.key !== key);
    this.setState({ data: filteredData });
    this.props.onChangeSampleVal(filteredData);
  };

  render() {
    const { t, getChartVariable, getTableVariable, errorMessages, isGenerateFormPage = false } = this.props;
    let repeatBlockActionTrans = t(
      `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.REPEAT_BLOCK_ACTION.key}`,
      COMPLEX_VARIABLES_SIDEBAR.REPEAT_BLOCK_ACTION.value,
    );
    let repetitiveBlockTrans = t(
      `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.REPETITIVE_BLOCK_LABEL.key}`,
      COMPLEX_VARIABLES_SIDEBAR.REPETITIVE_BLOCK_LABEL.value,
    );
    let addRowAction = `Add row`;
    let row = 'Row ';
    let deleteBlockTrans = t(
      `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.DELETE_REPEATED_BLOCK_TOOLTIP.key}`,
      COMPLEX_VARIABLES_SIDEBAR.DELETE_REPEATED_BLOCK_TOOLTIP.value,
    );
    let deleteConfirmTrans = t(
      `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.DELETE_REPEATED_BLOCK_CONFIRMATION_TITLE.key}`,
      COMPLEX_VARIABLES_SIDEBAR.DELETE_REPEATED_BLOCK_CONFIRMATION_TITLE.value,
    );

    const isTable = this.props?.columnData?.type === VARIABLE_TYPE.TABLE_OBJECT;
    const isObject = isTable && this.props.nested && !this.props.isArray;

    return (
      <TableSection nested={this.props.nested}>
        {!isObject && !this.props.isInteractiveDesign && <a onClick={this.handleAdd}>{isTable ? addRowAction : repeatBlockActionTrans}</a>}
        <Collapse
          bordered={false}
          defaultActiveKey={['']}
          expandIcon={({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />}
        >
          {this.state.data?.map((record, index) => {
            return (
              <Panel
                header={isObject ? 'Details' : `${isTable ? row : repetitiveBlockTrans} ${index + 1}`}
                key={index}
                style={customPanelStyle}
                extra={
                  this.state.data?.length > 1 && !this.props.isInteractiveDesign && (
                    <Actions>
                      <Tooltip title={deleteBlockTrans}>
                        <Popconfirm
                          title={deleteConfirmTrans}
                          onConfirm={() => this.handleDelete(record.key)}
                        >
                          <Icon type="delete" onClick={e => e.stopPropagation()} />
                        </Popconfirm>
                      </Tooltip>
                    </Actions>
                  )
                }
              >
                <div className="block">
                  {record.value.map((variable, index) => {
                    const splittedLabel = isGenerateFormPage
                      ? variable?.name?.split('.')?.join(' ')
                      : variable.name;
                    return (
                      <>
                        <VariableDataContainer
                          isObject={variable.type === VARIABLE_TYPE.CHART_OBJECT || variable.type === VARIABLE_TYPE.TABLE_OBJECT}
                          style={{
                            alignItems: variable.type !== 'ListString' && 'center',
                            rowGap: '10px',
                          }}
                        >
                          <div
                            className="varName"
                            style={{ marginTop: variable.type !== 'ListString' && 0 }}
                          >
                            {variable.type.toLowerCase() === 'string' && (
                              <Tooltip
                                placement="top"
                                title={t(
                                  TEMPLATE_VARIABLES_SIDEBAR.STRING_VARIABLE_TOOLTIP.key,
                                  TEMPLATE_VARIABLES_SIDEBAR.STRING_VARIABLE_TOOLTIP.value,
                                )}
                              >
                                <div className="variable-type">S</div>
                              </Tooltip>
                            )}
                            {variable.type === 'boolean' && (
                              <Tooltip
                                placement="top"
                                title={this.props.t(
                                  TEMPLATE_VARIABLES_SIDEBAR.BOOLEAN_VARIABLE_TOOLTIP.key,
                                  TEMPLATE_VARIABLES_SIDEBAR.BOOLEAN_VARIABLE_TOOLTIP.value,
                                )}
                              >
                                <div className="variable-type">B</div>
                              </Tooltip>
                            )}
                            {variable.type === 'ListString' && (
                              <Tooltip
                                placement="top"
                                title={this.props.t(
                                  TEMPLATE_VARIABLES_SIDEBAR.MULTI_VALUE_VARIABLE_TOOLTIP.key,
                                  TEMPLATE_VARIABLES_SIDEBAR.MULTI_VALUE_VARIABLE_TOOLTIP.value,
                                )}
                              >
                                <div className="variable-type">L</div>
                              </Tooltip>
                            )}
                            {variable.type.toLowerCase() === 'date' && (
                              <Tooltip
                                placement="top"
                                title={this.props.t(
                                  TEMPLATE_VARIABLES_SIDEBAR.DATE_VARIABLE_TOOLTIP.key,
                                  TEMPLATE_VARIABLES_SIDEBAR.DATE_VARIABLE_TOOLTIP.value,
                                )}
                              >
                                <div className="variable-type">D</div>
                              </Tooltip>
                            )}
                            {variable.type === VARIABLE_TYPE.CHART_OBJECT && (
                              <Tooltip
                                placement="top"
                                title={t(
                                  TEMPLATE_VARIABLES_SIDEBAR.CHART_VARIABLE_TOOLTIP.key,
                                  TEMPLATE_VARIABLES_SIDEBAR.CHART_VARIABLE_TOOLTIP.value,
                                )}
                              >
                                <div className="variable-type">C</div>
                              </Tooltip>
                            )}
                            {variable.type === VARIABLE_TYPE.TABLE_OBJECT && (
                              <Tooltip
                                placement="top"
                                title={t(
                                  TEMPLATE_VARIABLES_SIDEBAR.TABLE_VARIABLE_TOOLTIP.key,
                                  TEMPLATE_VARIABLES_SIDEBAR.TABLE_VARIABLE_TOOLTIP.value,
                                )}
                              >
                                <div className="variable-type">T</div>
                              </Tooltip>
                            )}
                            <p>{splittedLabel} {variable?.isMandatory && !this.props.nested ? <span style={{color: 'red', fontSize: '16px'}}>*</span>: null}</p>
                          </div>
                          <div
                            style={{
                              width: variable.type === VARIABLE_TYPE.CHART_OBJECT || variable.type === VARIABLE_TYPE.TABLE_OBJECT
                                ? 'inherit' : '45%',
                            }}
                          >
                            {variable.type.toLowerCase() === 'date'
                              ? this.props.getBlockDatevariable(variable, record)
                              : variable.type === 'ListString'
                              ? this.props.getBlockListVariable(variable, record)
                              : variable.type === VARIABLE_TYPE.CHART_OBJECT
                              ? getChartVariable(variable, true)
                              : (variable.type === 'object' || variable.type === VARIABLE_TYPE.TABLE_OBJECT)
                              ? getTableVariable(variable, variable.value, isTable)
                              : this.props.getBlockStringVariable(variable, record)}
                          </div>
                        </VariableDataContainer>
                        {Object.keys(errorMessages).length &&
                        [...VARIABLE_PRIMITIVE_TYPES, VARIABLE_TYPE.LIST_OF_STRINGS].includes(
                          variable.type,
                        ) ? (
                          <ErrorLabel
                            errorMessages={errorMessages}
                            variable={variable}
                            t={t}
                            isObject={true}
                          />
                        ) : null}
                      </>
                    );
                  })}
                </div>
              </Panel>
            );
          })}
        </Collapse>
      </TableSection>
    );
  }
}

const ChangeVariableValue = Form.create()(EditableTable);
export default withTranslation(NAMESPACES)(ChangeVariableValue);
